import { locationsProfilesService } from '@services';
import { locationsProfilesConstants } from '@constants/locations-profiles';

export const locationsProfilesActions = {
    get,
    reset,
};

let nextRequestId = 0;

function request(ownerId, requestId) {
    return { type: locationsProfilesConstants.LOCATIONS_PROFILES_FETCH, ownerId, requestId };
}

function success(ownerId, requestId, data) {
    return { type: locationsProfilesConstants.LOCATIONS_PROFILES_SUCCESS, ownerId, requestId, data };
}

function failure(ownerId, requestId) {
    return { type: locationsProfilesConstants.LOCATIONS_PROFILES_ERROR, ownerId, requestId };
}

function reset() {
    return { type: locationsProfilesConstants.LOCATIONS_PROFILES_RESET };
}

function get(locationId) {
    return dispatch => {
        const requestId = ++nextRequestId;
        dispatch(request(locationId, requestId));
        return locationsProfilesService.get(locationId).then(
            data => dispatch(success(locationId, requestId, data)),
            () => dispatch(failure(locationId, requestId)),
        );
    };
}
